import React, { useState } from "react";

import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SectionItem from "../../../../components/section/section-item/SectionItem";
import { useAudioPlayerContext } from "../../../../contexts/AudioPlayerContext";
import { updateVoice } from "../../../../redux/actions/InfoActions";
import { postOpenModal } from "../../../../utils/utilPostMessage";
import ChooseVoiceInline from "./ChooseVoiceInline";
import ReceptionistVoiceSelectedSection from "./ReceptionistVoiceSelectedSection";

const ReceptionistVoice = () => {
  const dispatch = useDispatch();
  const audioPlayerContext = useAudioPlayerContext();
  const externalOverlay = useSelector((state) => state.info.externalOverlay);
  const updatedVoice = useSelector((state) => state.info.updatedVoice);
  const [isChooseReceptionistOpen, setIsChooseReceptionistOpen] = useState(false);
  const voices = useSelector((state) => state.info.voices);

  const onOpen = () => {
    if (externalOverlay) {
      const message = {
        childrenType: "choose-receptionist",
        selectedVoice: updatedVoice,
        voices: voices,
      };
      postOpenModal(message);
    }
    setIsChooseReceptionistOpen(true);
    audioPlayerContext.stopAudio();
  };

  const onClose = () => {
    setIsChooseReceptionistOpen(false);
  };

  useEffect(() => {
    if (externalOverlay) {
      const handleMessage = (event) => {
        const data = event.data;
        if (data.type === "overlay-to-snippet") {
          const extra = data.extra;
          if (extra.action === "overlay-closed") {
            onClose();
            return;
          }

          if (extra.action === "choose-receptionist") {
            onVoiceSelected(extra.voiceObject);
          }
        }
      };
      window.addEventListener("message", handleMessage);

      return () => {
        window.removeEventListener("message", handleMessage);
      };
    }
  }, []);

  const onVoiceSelected = (voiceObject) => {
    console.log("onVoiceSelected", voiceObject);
    dispatch(updateVoice(voiceObject.id, voiceObject.language));
  };

  const sectionContent = (
    <>
      <div className="w-full flex flex-col justify-center items-start md:space-x-8">
        <ReceptionistVoiceSelectedSection
          isChooseReceptionistOpen={isChooseReceptionistOpen}
          onOpenSelection={onOpen}
          onCloseSelection={onClose}
        />
      </div>
      {!externalOverlay && (
        <ChooseVoiceInline
          selectedVoice={updatedVoice}
          onVoiceSelected={onVoiceSelected}
          isChooseReceptionistOpen={isChooseReceptionistOpen}
          setIsChooseReceptionistOpen={setIsChooseReceptionistOpen}
        />
      )}
    </>
  );

  return <SectionItem title="Receptionist voice" content={sectionContent} />;
};

export default ReceptionistVoice;
